function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * In-game crypto payment preferences — opened from GameMenu on crypto-staked games.
 *
 * Reads/writes wallet preferences in app.options.gameprefs.
 * Absent preferences are treated as disabled (unchecked) in this UI.
 */

var GameCryptoSettingsTemplate = require('./game-crypto-settings.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var GameCryptoSettings = /*#__PURE__*/function () {
  function GameCryptoSettings(app, mod) {
    _classCallCheck(this, GameCryptoSettings);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
  }

  /**
   * Explicit wallet preference only. Missing / null → false (unchecked).
   */
  return _createClass(GameCryptoSettings, [{
    key: "readWalletPref",
    value: function readWalletPref(key) {
      var _this$app$options;
      var pref = (_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.gameprefs) === null || _this$app$options === void 0 ? void 0 : _this$app$options[key];
      if (pref === undefined || pref === null) {
        return false;
      }
      return !!pref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$app,
        _this = this;
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.addStylesheet) {
        this.app.browser.addStylesheet('/crypto/style.css');
      }
      this.overlay.show(GameCryptoSettingsTemplate({
        outboundTrusted: this.readWalletPref('crypto_transfers_outbound_trusted'),
        inboundTrusted: this.readWalletPref('crypto_transfers_inbound_trusted')
      }));
      var saveBtn = document.getElementById('game_crypto_settings_save');
      if (saveBtn) {
        saveBtn.onclick = function () {
          var outbound = document.getElementById('game_crypto_settings_outbound');
          var inbound = document.getElementById('game_crypto_settings_inbound');
          _this.app.options.gameprefs = _this.app.options.gameprefs || {};
          _this.app.options.gameprefs.crypto_transfers_outbound_trusted = outbound !== null && outbound !== void 0 && outbound.checked ? 1 : 0;
          _this.app.options.gameprefs.crypto_transfers_inbound_trusted = inbound !== null && inbound !== void 0 && inbound.checked ? 1 : 0;
          _this.app.storage.saveOptions();
          _this.overlay.close();
        };
      }
    }
  }]);
}();
module.exports = GameCryptoSettings;